export { Context } from '@datadog/browser-core'
export type DataDogSampleRate = number

export function isDataDogSampleRate(value: unknown): value is DataDogSampleRate {
  return typeof value === 'number' && !Number.isNaN(value) && 0 <= value && value <= 100
}
export const DEFAULT_SAMPLE_RATE: DataDogSampleRate = 100
